/* eslint-disable import/no-unresolved */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MAIN_ICON_COLORS, ManageAddressesPaperIcon } from 'assets/components';
import WhitelistManagementModal from '../modals/WhitelistManagementModal';
import {
  useLedgerFilteredCurrencies,
  useLedgerFilteredWallets,
} from '../../../utilities/sharedHooks/ledgerWallets';
import { WALLETS_ALL } from '../../Accounts/queries';
import { showAlert } from '../../../utilities/notifications';
import Icon from '../../../components/Icon';
import { ICONS } from '../../../components/Icon/constants';
import { useLedgerAccounts } from '../../../utilities/sharedHooks/ledgerSDKHooks';
import { currencies } from '../../../utilities/constants';
import { SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY } from '../../../utilities/sharedQueries';

const Security = () => {
  const { t: translate } = useTranslation();
  const [showWhitelistManagementModal, setShowWhitelistManagementModal] = useState(false);
  const [wallet, setWallet] = useState(null);
  const [wallets, setWallets] = useState(null);

  const [ledgerAccounts] = useLedgerAccounts();
  const { data: supportedCurrencies } = useLedgerFilteredCurrencies([
    SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  ]);

  const ledgerAccountWallet = useCallback(
    (walletSelected) => {
      if (ledgerAccounts) {
        if (
          supportedCurrencies &&
          supportedCurrencies[walletSelected?.coin] &&
          supportedCurrencies[walletSelected?.coin].is_erc20_token &&
          ledgerAccounts[currencies.ETH.icon.toLowerCase()]
        ) {
          return ledgerAccounts[currencies.ETH.icon.toLowerCase()];
        }
        return ledgerAccounts[walletSelected?.coin];
      }
      return null;
    },
    [ledgerAccounts, supportedCurrencies]
  );

  const { refetch: refetchAllWallets } = useLedgerFilteredWallets(WALLETS_ALL, {
    onSettled(data, error) {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      }
      setWallets(data);
      const currentWallet = data?.find((w) => w.coin.toLowerCase() === data[0].coin.toLowerCase());
      if (currentWallet) {
        setWallet(currentWallet);
      }
    },
  });

  const editInformationButton = (buttonText) => (
    <button
      className="btn border-grey border rounded-5 text-f6 py-2 px-3 text-bold"
      type="button"
      style={{ minWidth: `5.9rem`, minHeight: '2.75rem' }}
      onClick={() => setShowWhitelistManagementModal(true)}>
      {buttonText}
    </button>
  );

  useEffect(() => {
    refetchAllWallets();
  }, [refetchAllWallets]);

  return (
    <>
      <div className="d-flex flex-column w-100 h-lg-100 h-md-100 h-sm-100 h-80vh">
        <p className="text-f3 text-dark pe-5 text-bold letter-spacing-1 line-height-sm-1 line-height-2">
          {translate('settings_security_tab_label')}
        </p>
        <p className="mt-3 text-f6 text-shadow letter-spacing-3">
          {translate('settings_security_tab_desc')}
        </p>

        <div className="d-sm-block d-none mt-4 p-3 bg-lighter rounded-extra">
          <div className="flex-row d-flex align-items-center justify-content-start w-100">
            <ManageAddressesPaperIcon />
            <div className="text-start d-flex flex-column">
              <p className="text-bold letter-spacing-2" style={{ lineHeight: '24px' }}>
                {translate('whitelisting_addresses')}
              </p>
              <span className="text-shadow text-f6 letter-spacing-3">
                {translate('whitelisting_addresses_subtitle')}
              </span>
            </div>

            <div className="ms-auto d-sm-block d-none">
              {editInformationButton(translate('setting_manage_btn_text'))}
            </div>
          </div>
        </div>

        <div
          role="presentation"
          tabIndex={-1}
          onClick={() => setShowWhitelistManagementModal(true)}
          className="d-sm-none d-flex flex-row justify-content-start align-items-center py-3 bg-lighter px-3 mt-4 rounded-extra">
          <div
            className="rounded-max bg-settings-icon me-3"
            style={{ height: '2.3rem', width: '3.5rem', paddingTop: '5px' }}>
            <div className="w-100" style={{ height: '16px', width: '16px' }}>
              <Icon icon={ICONS.PAPER} color={MAIN_ICON_COLORS.INFO} />
            </div>
          </div>
          <div className="d-flex flex-column pe-3">
            <p className="text-dark text-f5">
              <b>{translate('whitelisting_addresses')}</b>
            </p>
            <p className="text-shadow text-f6 letter-spacing">
              {translate('whitelisting_addresses_subtitle')}
            </p>
          </div>
          <div className="ms-auto">
            <i
              style={{ width: '1rem' }}
              className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
            />
          </div>
        </div>
      </div>
      {showWhitelistManagementModal && (
        <WhitelistManagementModal
          hide={() => setShowWhitelistManagementModal(false)}
          wallet={wallet}
          wallets={wallets}
          ledgerAccount={ledgerAccountWallet(wallet)}
          onChangeWallet={setWallet}
        />
      )}
    </>
  );
};

export default Security;
